// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2FUC8","label":"Category_label__1qTOd","content":"Category_content__2jxC0","header":"Category_header__1FG9J","location":"Category_location__3pOb6"};